// Standard imports
import "react-data-grid/lib/styles.css";
import Header from "./datasheets/views/common/Header";
import Footer from "./datasheets/views/common/Footer";
import "./App.css";
import { Provider as JotaiProvider, useAtomValue, useSetAtom } from "jotai";
import { DndProvider } from "react-dnd";
import { backendForDND } from "utils/DragAndDrop";
import ViewContainer from "datasheets/views/common/ViewContainer";
import { useEffect } from "react";
import { isWorkbookDirtyAtom } from "datasheets/model/atoms/WorkbookAtoms";
import {
  canAutosaveAtom,
  saveWorkbookAtom,
} from "datasheets/model/atoms/WorkbookActionAtoms";
import { UserCommunicationsToast } from "datasheets/components/UserCommunicationsToast";

interface AppProps {
  testMode?: boolean;
}

function App(props: AppProps) {
  return <JotaiProvider>{NakedApp(props)}</JotaiProvider>;
}

export function NakedApp(props: AppProps) {
  return (
    <DndProvider backend={backendForDND}>
      <div className="App">
        <Autosave />
        <Header />
        <UserCommunicationsToast />
        <ViewContainer className="View" testMode={props.testMode} />
        <Footer />
      </div>
    </DndProvider>
  );
}

function Autosave() {
  const isDirty = useAtomValue(isWorkbookDirtyAtom);
  const canAutosave = useAtomValue(canAutosaveAtom);
  const saveWorkbook = useSetAtom(saveWorkbookAtom);
  const minutesBetweenSaves = 1;
  const saveIntervalInMs = minutesBetweenSaves * 60 * 1000;
  useEffect(() => {
    let interval = isDirty
      ? setTimeout(function tick() {
          if (isDirty) {
            // If isDirty has been cleared elsewhere, this will cancel the autosave until next edit
            if (canAutosave) {
              console.log("Autosaving workbook", new Date());
              saveWorkbook();
            } else {
              // Reschedule if we can't save for some reason
              console.log("Not Autosaving workbook", new Date());
              interval = setTimeout(tick, saveIntervalInMs);
            }
          }
        }, saveIntervalInMs)
      : undefined;
    return () => clearTimeout(interval);
  }, [isDirty, saveWorkbook, canAutosave, saveIntervalInMs]);
  return <></>;
}

export default App;
